module.exports = __webpack_public_path__ + "img/Asset8.95b78447.png";